import { render, staticRenderFns } from "./tamplateData.vue?vue&type=template&id=e06eb5a4&scoped=true"
import script from "./tamplateData.vue?vue&type=script&lang=js"
export * from "./tamplateData.vue?vue&type=script&lang=js"
import style0 from "./tamplateData.vue?vue&type=style&index=0&id=e06eb5a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06eb5a4",
  null
  
)

export default component.exports